import { Category } from '@/types/category'
import { api } from '@/utils/api'
import { apiCategory } from '@/utils/api/url'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'
import { useQuery } from '@tanstack/react-query'

export const QUERY_KEY_CATEGORY = 'CATEGORY_SERVICE'

export const useGetCategories = ({ branch }: { branch: string }) => {
  const category = useQuery({
    queryKey: [QUERY_KEY_CATEGORY, branch],
    queryFn: () =>
      api
        .get(createRouteForAPI(apiCategory, { branch }))
        .then(({ data }) => data as Category[]),
    enabled: !!branch,
    staleTime: 60 * (60 * 1000), // 60mins
  })
  return category
}
